import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

const ChatbotFlowsList = () => import('./Index.vue');
const ChatbotFlowEditor = () => import('./Editor.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/chatbot-flows'),
      component: SettingsWrapper,
      props: { keepAlive: false },
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'chatbot_flows_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'chatbot_flows_list',
          component: ChatbotFlowsList,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL(
        'accounts/:accountId/settings/chatbot-flows/new'
      ),
      name: 'chatbot_flows_new',
      component: ChatbotFlowEditor,
      meta: {
        permissions: ['administrator'],
      },
    },
    {
      path: frontendURL(
        'accounts/:accountId/settings/chatbot-flows/:flowId/edit'
      ),
      name: 'chatbot_flows_edit',
      component: ChatbotFlowEditor,
      meta: {
        permissions: ['administrator'],
      },
    },
  ],
};
